
import { supabase } from '@/integrations/supabase/client';
import { mockTerraces } from '@/data/mockTerraces';
import { Terrace } from '@/types/terrace';
import { DatabaseTerrace } from '@/types/api';
import { transformDatabaseTerrace } from './dataTransforms';
import { logger } from '@/lib/utils/logger';

const componentLogger = logger.forComponent('TerraceDataService');

export const fetchTerraceByIdentifier = async (identifier: string): Promise<Terrace | null> => {
  componentLogger.debug('Fetching terrace with identifier', { identifier });
  
  // Check if identifier is a UUID (fallback for old URLs)
  const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(identifier);
  
  let query = supabase.from('terraces').select('*');
  
  if (isUUID) {
    query = query.eq('id', identifier);
  } else {
    query = query.eq('slug', identifier);
  }
  
  const { data, error: supabaseError } = await query.maybeSingle();

  if (supabaseError) {
    componentLogger.error('Error fetching terrace from database', {}, supabaseError);
    // Fall back to mock data
    const mockTerrace = mockTerraces.find(t => 
      t.slug === identifier || t.id === identifier
    );
    if (mockTerrace) {
      return mockTerrace;
    } else {
      throw new Error('Terrace not found');
    }
  } else if (data) {
    componentLogger.debug('Raw terrace data from database', { 
      name: data.name, 
      hasPhotoUrl: !!data.photo_url,
      slug: data.slug 
    });
    
    return transformDatabaseTerrace(data as DatabaseTerrace);
  } else {
    // No data found in database, try mock data
    const mockTerrace = mockTerraces.find(t => 
      t.slug === identifier || t.id === identifier
    );
    if (mockTerrace) {
      return mockTerrace;
    } else {
      throw new Error('Terrace not found');
    }
  }
};
